interface PurchaseSummaryTableProps {
  tableData: { title: string; value: string | number }[];
}

const PurchaseSummaryTable = ({ tableData }: PurchaseSummaryTableProps) => {
  return (
    <div className="table-summary mb-12 table-auto">
      <table className="purchase-summary">
        <tbody className="purchase-summary--body">
          {tableData?.map(({ title, value }, idx) => (
            <tr className="purchase-summary--row" key={idx}>
              <td className="purchase-summary--data title">{title}</td>
              <td className="purchase-summary--data value">{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PurchaseSummaryTable;
